import { CommonModule, Location } from '@angular/common';
import { Component, LOCALE_ID } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../../user/services/user.service';
import { VialAssistanceService } from '../../services/vial-assistance.service';
import { LoaderService } from '../../../../../shared/services/loader.service';
import { VialAssistanceIdentifier, VialAssistanceRequest } from '../../models/vial-assistance-request.model';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { MatDialog } from '@angular/material/dialog';
import { AsisstancesConfirmDialogComponent } from '../../assistances-confirm-dialog.component';
import { VialAssistanceSubserviceRequest } from '../../models/vial-assistance-subservice-request.model';

@Component({
  selector: 'app-vial-assistance-confirm',
  imports: [
    CommonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule
    //MatProgressBar

  ],
  templateUrl: './vial-assistance-confirm.component.html',
  styleUrl: './vial-assistance-confirm.component.scss',
  providers: [

    { provide: LOCALE_ID, useValue: 'es-ES' },       // Angular pipes, date formatting
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }  // Angular Material components
  ],
})
export class VialAssistanceConfirmComponent {

  nameService: string = "";
  hideHeader: boolean = false;
  selectedDate: Date | null = null;
  selectedHour: any = {};
  selectedAgenda: boolean = false;
  hoursDate: any[] = [
    { id: 1, start: '9:00 am', end: '10:00 am' },
    { id: 1, start: '10:00 am', end: '11:00 am' },
    { id: 1, start: '11:00 am', end: '12:00 am' },
    { id: 1, start: '12:00 am', end: '1:00 pm' },
    { id: 1, start: '1:00 am', end: '2:00 am' },
  ]

  provideServiceData: any = {};

  constructor(
    private userService: UserService,
    private apiService: VialAssistanceService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private loader: LoaderService) {

  }

  ngOnInit(): void {
    registerLocaleData(localeEs);

    this.route.queryParams.subscribe((param) => {
      if (param) {
        this.provideServiceData = param;
        this.hideHeader = param['hideHeader'] == 'true'
        this.nameService = param['nameService'] ? param['nameService'] : "";
      }
    });
    this.getDetailUser();
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          console.log(res)
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  onDateChange(newDate: Date | null): void {
    this.selectedDate = newDate;
  }

  onHourChange(hour: any) {
    this.selectedHour = hour;
  }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(' ');
    return {
      firstName: parts[0] || '',
      lastName: parts[1] || '',
      secondLastName: parts.slice(2).join(' ') || ''
    };
  }

  goToConfirm(): void {
    const dialogRef = this.dialog.open(AsisstancesConfirmDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader.show();
        const userData = JSON.parse(localStorage.getItem('user') || '{}');
        const address = JSON.parse(this.provideServiceData.selectedAddress || '{}');
        const account = parseInt(localStorage.getItem('account') || '0', 0);
        const vehicle = JSON.parse(this.provideServiceData.vehicleSelected || {});

        console.log('address = ', address);
        const payload: VialAssistanceRequest = {
          identifier: {
            tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
            app: 'PortalAsistencia',
          },
          petition: {
            serviceId: this.provideServiceData.clServicio || 1,
            subServiceId: this.provideServiceData.clSubservicio || this.getSubserviceVialType(this.nameService),
            hasAssistance: false,
            key: userData.memberships || '',
            areaCode1: "",
            phone1: userData.phone || '',
            stateCode: address?.codeent || '',
            municipalityCode: address?.codemun || "",
            callenum:address?.streetNumber || "",
            cp: address?.cp || "",
            colonia:address?.colony || "",
            statusId: 0,
            accountId: account,
            appUserId: 1,
            countryId: 115,
            contactTypeId: 15,
            serviceTypeId: 1,
            sendCharge: false,
            hasAppointment: false,
            isRelevant: false,
            gender: 1,
            isOk: true,
            hasQuotation: false,
            isSise2: true,
            serviceReceptionId: 10,
            personId: 1,
            username: userData.name || '',
            paternalSurname: "",
            userSecondLastName: "",
            contactName: userData.name || '',
            userFirstNamePf: "",
            userLastNamePf: "",
            userSecondLastNamePf: "",
            ourUser: userData.username || '',
            externalCabRepName: "API CLIENTES",
            folio: crypto.randomUUID(),
            longitude: `${address?.lat}`,
            latitude: `${address?.lng}`,
            incidentDescription: "",
            clRecepcionServicio: 10,
            email: '',
          }
        }

        this.apiService.postVialAssistance(payload).subscribe({
          next: (res) => {
            if (res.code === 200) {
              const payloadSubService: VialAssistanceSubserviceRequest = {
                identifier: {
                  tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
                  app: 'PortalAsistencia',
                },
                petition: {
                  clexpediente: res.response.id,
                  claveamis: vehicle.id,
                  codigomarca: vehicle.catalogbrand.reference,
                  modelo: vehicle.model,
                  placas: vehicle.plates,
                  noserie: vehicle.serialNumber,
                  nivel: vehicle.shielding ? vehicle.shieldingCatalog.description : '0',
                  clcolorauto: vehicle.colorcatalog.idColor,
                  clblindaje: vehicle.shielding ? vehicle.shieldingCatalog.idShielding : 0,
                  cllugarevento: 2,
                  latitudorig: address?.lat,
                  longitudorig: address?.lng
                }
              }

              this.apiService.postVialssistanceSubservice(payloadSubService,  this.getSubserviceVialType(this.nameService).toString()).subscribe({
                next:(resSub)=>{
                  this.router.navigate(['/solicitud/detalle/', res.response.id ],{
                    queryParams: {clexpediente:res.response.id, dsservicio: 'Vial', dssubservicio:this.nameService, isConfirmed:true}
                  });
                  this.loader.hide();
                },
                error: (err) => {
                  this.loader.hide();
                  if (err.status === 409) {
                    console.error('Error inesperado:', err);
                  } else {
                    console.error('Error inesperado:', err);
                  }
                },
              });

            } else {

            }
          },
          error: (err) => {
            this.loader.hide();
            if (err.status === 409) {
              console.error('Error inesperado:', err);
            } else {
              console.error('Error inesperado:', err);
            }
          },
        });

      } else {

      }
    });
  }


  goToBack(): void {
    this.location.back();
  }

  toggleAgenda() {
    this.selectedAgenda = !this.selectedAgenda;
  }

  private getSubserviceVialType(type: string) {
    switch (type) {
      case 'Arrastre de Grúa': return 211;
      case 'Paso de Corriente': return 212;
      case 'Cambio de Llanta':return 213;
      case 'Suministro de Gasolina':return 214;
      default: return 211;
    }
  }
}
